import { deltaOf, WINDOW_DAYS, type Trend } from "@shared/lib/dashboard-metrics";
import { cn } from "@shared/lib/utils";
import { useT } from "@shared/client/locale";

/**
 * Une mesure du tableau de bord : libellé · valeur · comparaison en toutes
 * lettres. Pas d'icône, pas de pastille de tendance ni de sparkline décorative :
 * l'écart avec la période précédente se lit dans une phrase, et la couleur ne
 * sert qu'à signaler une baisse.
 *
 * Pensée pour vivre dans une bande (`StatGroup` de components/admin/ui.tsx) :
 * la cellule n'a pas de bordure propre.
 */
export function StatTile({ label, trend, caption }: { label: string; trend: Trend; caption: string }) {
  const delta = deltaOf(trend);
  const copy = useT().dashboard.statTile;

  return (
    <div className="min-w-0 border-r border-b px-5 py-4">
      <span className="block text-[12.5px] text-muted-foreground">{label}</span>
      <p className="m-0 mt-1.5 flex items-baseline gap-2">
        <strong className="text-[24px] leading-none font-semibold tracking-[-0.02em] tabular-nums">{trend.value}</strong>
        <span
          className={cn("text-[12.5px] tabular-nums text-muted-foreground", delta.direction === "down" && "text-destructive")}
          title={copy.comparedTo(WINDOW_DAYS)}
        >
          {delta.direction === "flat" ? copy.stable : copy.versus(delta.label, WINDOW_DAYS)}
        </span>
      </p>
      <small className="mt-1.5 block truncate text-[12px] text-subtle-foreground">{caption}</small>
    </div>
  );
}
